module.exports = __webpack_public_path__ + "img/file_edit_drop.8e7b0587.png";